import React from 'react'

import { TABLE_OF_CONTENT_GROW_LEAF_CARD } from 'utils/testing/testIDs'

import {
  CardContainer,
  CardContent,
  CardIndex,
  CardTitle,
} from './styled-components'

const Card = ({
  backgroundColor,
  content,
  index,
  title,
}: {
  backgroundColor: string
  content: string
  index: number
  title: string
}): React.ReactElement => {
  return (
    <CardContainer
      backgroundColor={backgroundColor}
      data-testid={TABLE_OF_CONTENT_GROW_LEAF_CARD}
    >
      <CardIndex>{index + 1}</CardIndex>
      <CardTitle>{title}</CardTitle>
      <CardContent>{content}</CardContent>
    </CardContainer>
  )
}

export { Card }
